var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 77,
    viewBox: "0 0 55 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6512 37.632C54.6512 17.1264 42.3632 0.153589 27.3872 0.153589C12.488 0.153589 0.200012 17.1264 0.200012 37.632C0.200012 58.1376 12.4112 75.1872 27.3872 75.1872C33.992 75.1872 40.0592 71.8848 44.2064 67.2L51.5024 76.032L54.6512 73.344L46.8176 64.0512C51.5024 57.6768 54.6512 48.1536 54.6512 37.632ZM44.1296 60.8256L35.4512 50.3808L32.3024 52.992L41.5952 64.128C37.9856 68.352 32.9168 71.1168 27.3872 71.1168C14.6384 71.1168 4.27041 56.2944 4.27041 37.632C4.27041 19.0464 14.6384 4.22399 27.3872 4.22399C40.2128 4.22399 50.504 19.0464 50.504 37.632C50.5808 47.0784 47.8928 55.4496 44.1296 60.8256Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperQ);
export default __webpack_public_path__ + "static/media/UPPER_Q.ad530de1196e4bcc9fb4c8922ead42a4.svg";
export { ForwardRef as ReactComponent };